import {
  FunctionName,
  priceConfig,
  UserIdentity,
} from '@/components/RightProvider/const';
import { LimitConfig } from '@/components/RightProvider/type';
import { IDENTITYKEY } from '@/store/User';
import { AIFunction } from '@/utils/const';
import { isDev, isPre, isQA } from '@/utils/envHelper';
import { fc_purchase_alert_expose, TPlan } from '@/utils/eventlog/eventNewConfig';

import { TabActiveKey } from '..';
// import { FeatureListMap } from '../components/comboPanel';

export const FWebsiteEmail = 'support@falcocut.ai';
export const BWebsiteEmail = 'boomcut.ai@quvideo.com';

// function formatTipDesc(
//   feature: keyof typeof priceConfig,
//   priceConfig: { [key: string]: number },
// ) {
//   switch (feature) {
//     case 'subtitleRemove':
//       return { intl: 'merror.sub.pay.sr', num: priceConfig.subtitleRemove };
//     case 'textTranslation':
//       return { intl: 'merror.sub.pay.tt', num: priceConfig.textTranslation };
//     case 'textToSpeech':
//       return { intl: 'merror.sub.pay.tts', num: priceConfig.textToSpeech };
//     case 'avatarVideo':
//       return { intl: 'merror.sub.pay.ls', num: priceConfig.avatarVideo };
//     case 'faceSwap':
//       return { intl: 'merror.sub.pay.vfs', num: priceConfig.faceSwap };
//     case 'lipsync':
//       return { intl: 'merror.sub.pay.ls', num: priceConfig.avatarVideo };
//     default:
//       return { intl: '', num: 0 };
//   }
// }

// 国际化所有功能点和对应tip提示
export function formatFeature(
  feature: FunctionName,
  priceData?: LimitConfig[keyof LimitConfig]['priceConfig'],
) {
  let result: { text: string; tip: Array<{ intl: string; num: number }> } = {
    text: '',
    tip: [],
  };

  switch (feature) {
    case 'subtitleRemove':
      result.text = 'bc.removal';
      break;
    case 'subtitleTranslate':
      result.text = 'merror.sub.vt';
      break;
    case 'audioTranslate':
      result.text = 'merror.sub.at';
      break;
    case 'digitalHumanVideo':
      result.text = 'merror.sub.ls';
      break;
    case 'videoFaceMerge':
      result.text = 'merror.sub.vfs';
      break;
    case 'textEdit':
      result.text = 'bc.text.style.edit';
      break;
    case 'lipSync':
      result.text = 'Translation-with-lipsync';
      break;
    case 'removeWaterMark':
      result.text = 'Watermark-removal';
      break;
    case 'batchNum':
      result.text = 'Batch-process-videos';
      break;
    case 'digitalHumanNum':
      result.text = 'merror.sub.avatars.new';
      break;
    case 'voiceCloneNum':
      result.text = 'merror.sub.cv.new';
      break;
    case 'assetAvailablePeriod':
      result.text = 'Video-save-for-7-days';
      break;
    default:
      result.text = '';
  }
  // if (priceData) {
  //   const target =
  //     priceData[
  //       feature as Extract<
  //         FunctionName,
  //         | 'subtitleRemove'
  //         | 'subtitleTranslate'
  //         | 'audioTranslate'
  //         | 'digitalHumanVideo'
  //         | 'videoFaceMerge'
  //         | 'lipSync'
  //       >
  //     ];
  //   if (target) {
  //     result.tip = target.keys.map((item) => {
  //       return formatTipDesc(item as keyof typeof priceConfig, priceConfig);
  //     });
  //   }
  // }
  return result;
}

/**
 * 返回比特定数字小的最近数字
  const numbers = [1, 3, 5, 7, 9];
  console.log(findClosestNumber(numbers, 6)); // 5
  console.log(findClosestNumber(numbers, 6, "larger")); // 7

  // 测试对象数组
  const items: NumberItem[] = [
    { id: 'a', value: 1 },
    { id: 'b', value: 3 },
    { id: 'c', value: 5 },
    { id: 'd', value: 7 },
    { id: 'e', value: 9 }
  ];
  console.log(findClosestNumber(items, 6)); // { id: 'c', value: 5 }
  console.log(findClosestNumber(items, 6, "larger")); // { id: 'd', value: 7 }
 */
export interface NumberItem {
  id: string;
  value: number;
}

type CompareFunction = (value: number, target: number) => boolean;

export function findClosestNumber(
  items: NumberItem[] | number[],
  target: number,
  direction: 'smaller' | 'larger' = 'smaller',
): NumberItem | number | undefined {
  try {
    // 定义比较函数
    const compareFunc: CompareFunction =
      direction === 'smaller'
        ? (value, target) => value < target
        : (value, target) => value > target;

    // 统一处理数组格式
    const normalized: NumberItem[] =
      Array.isArray(items) && typeof items[0] === 'number'
        ? (items as number[]).map((num) => ({ id: String(num), value: num }))
        : (items as NumberItem[]);

    // 使用比较函数过滤
    const filtered = normalized.filter((item) => compareFunc(item.value, target));

    if (filtered.length === 0) return undefined;

    // 找到距离目标值最近的项
    const closest = filtered.reduce((closest, current) =>
      Math.abs(target - current.value) < Math.abs(target - closest.value)
        ? current
        : closest,
    );

    // 根据输入类型返回对应格式
    return Array.isArray(items) && typeof items[0] === 'number' ? closest.value : closest;
  } catch (error) {
    return 1;
  }
}

// 获取当前权益的上一个权益
export function getPrevVipType(
  type: 'freeVip' | 'basicVip' | 'advancedVip' | 'enterpriseVip',
) {
  switch (type) {
    case 'freeVip':
      return 'Everything-in-Free';
    case 'basicVip':
      return 'Everything-in-Standard';
    case 'advancedVip':
      return 'Everything-in-Pro';
    case 'enterpriseVip':
      return '';
  }
}

// 获取当前权益比上一个权益不同的项
// export const getDifferentialFeatures = (
//   currentType: UserIdentity,
//   prevType: UserIdentity,
//   config: LimitConfig,
//   displayFeature: string[],
// ) => {
//   // 如果没有上一等级，返回当前等级的所有展示功能
//   if (!prevType) {
//     return displayFeature;
//   }
//   const { batchNum: currBatchNum, ...curr } = config[currentType];
//   const { batchNum: prevBatchNum, ...prev } = config[prevType];
//   let currentData = config[currentType] as any;
//   let prevData = config[prevType] as any;
//   if (currBatchNum <= 1) {
//     currentData = curr;
//   }
//   if (prevBatchNum <= 1) {
//     prevData = prev;
//   }

//   const currentFeatures = new Set(
//     Object.entries(currentData)
//       .filter(([key, value]) => FeatureListMap.includes(key))
//       .map(([key]) => key),
//   );

//   const prevFeatures = new Set(
//     Object.entries(prevData)
//       .filter(([key, value]) => FeatureListMap.includes(key))
//       .map(([key]) => key),
//   );

//   let result = displayFeature.filter(
//     (feature) => currentFeatures.has(feature) && !prevFeatures.has(feature),
//   );
//   return result;
// };

export function getFeatureSource(feature: AIFunction) {
  switch (feature) {
    case AIFunction.VideoTranslate:
      return 0;
    case AIFunction.FaceSwap:
      return 1;
    case AIFunction.Removal:
      return 2;
    case AIFunction.Avatar2:
      return 3;
    case AIFunction.TopUpgrade:
      return 6;
    case AIFunction.VoiceClone:
      return 7;
    case AIFunction.Me:
      return 9;
    default:
      return AIFunction.Other;
  }
}

// 获取支付类型
export const getPlanTag = (
  skuType: IDENTITYKEY,
  dateType: 'month' | 'year' | 'once' | 'twoweek',
): TPlan => {
  if (dateType === 'once') {
    return 'Credit';
  }

  if (skuType === 'basicVip') {
    if (dateType === 'month') return 'S1';
    if (dateType === 'year') return 'S2';
  }

  if (skuType === 'advancedVip') {
    if (dateType === 'month') return 'P1';
    if (dateType === 'year') return 'P2';
  }

  return 'Other';
};
